import request from '@/utils/request'

export const getProductList = ({ page, size, keywords: productName, productState }) => {
  return request({
    url: `/trace/product/${page}/${size}`,
    params: {
      productName,
      productState
    }
  })
}

export const postProductEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/product',
    data
  })
}

export const putProductAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/product',
    data
  })
}

export const getProductDetail = (id) => {
  return request({
    url: `/trace/product/${id}`
  })
}

export const getProductName = (productName) => {
  return request({
    url: `/trace/product/name/${productName}`
  })
}

export const getProductBarcode = (barcode) => {
  return request({
    url: `/trace/product/barcode/${barcode}`
  })
}

export const deleteProductDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/product/${id}`
  })
}

export const delProductList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/product/all',
    data
  })
}
